import { Directive, HostListener, HostBinding, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[addMore]',
    standalone: false
})
export class AddMoreAutosuggestDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }
}
